import { message } from 'antd'
import { useEffect } from 'react'
import useTranslation from 'lib/i18n'
import { DEMO_REFUSED } from '../utils/axiosInstance'

// Says, wherever the demo account tried to change something, that it
// cannot: the api refused the write (utils/axiosInstance.ts).
export function DemoRefusal() {
  const { t } = useTranslation()
  useEffect(() => {
    const say = () => message.warning({ content: t('demo_read_only'), key: DEMO_REFUSED })
    window.addEventListener(DEMO_REFUSED, say)
    return () => window.removeEventListener(DEMO_REFUSED, say)
  }, [t])
  return null
}
